import { Component, OnInit, inject } from '@angular/core';

import {SessionService} from '@core';
import {NavigationService} from "planner-shared";
import {CookieService} from "ngx-cookie-service";
import {ErrorService} from "../../_core/services/error/error.service";

@Component({
    templateUrl: './server-error.component.html',
    standalone: false
})
export class ServerErrorComponent implements OnInit {
    private readonly sessionService = inject(SessionService);
    private readonly navigationService = inject(NavigationService);
    private readonly cookieService = inject(CookieService);
    private readonly errorService = inject(ErrorService);

    public sessionExpired: boolean;
    public requestId: string;
    public retriesExceeded: boolean;

    ngOnInit(): void {
        this.sessionExpired = this.sessionService.sessionExpired;
        this.requestId = this.sessionService.requestId;
        this.loadRetries();
    }

    public retry(): void {
        const previousPage = this.cookieService.get("previous-page");
        this.navigationService.navigate(Number(previousPage));
        this.updateRetries();
    }

    public returnToStepOne(): void {
        this.navigationService.navigateToStep1();
        this.updateRetries();
    }

    private loadRetries(): void {
        const retryRequestId = this.cookieService.get("retry-requestid");
        if (this.requestId !== retryRequestId) {
            this.cookieService.set("retry-requestid", this.requestId);
            this.cookieService.set("retry-count", "0");
        } else if (+this.cookieService.get("retry-count") >= 3) {
            this.errorCheck();
        }
    }

    private updateRetries(): void {
        let retriesCount = +this.cookieService.get("retry-count");
        const currentDateTimeSeconds = Math.floor(new Date().getTime() / 1000);
        if (retriesCount % 3 === 0) {
            this.cookieService.set("first-error", currentDateTimeSeconds.toString());
        } else if (retriesCount % 3 === 1) {
            this.cookieService.set("second-error", currentDateTimeSeconds.toString());
        } else if (retriesCount % 3 === 2) {
            this.cookieService.set("third-error", currentDateTimeSeconds.toString());
        }
        if (retriesCount >= 3) {
            this.errorCheck();
        }
        this.cookieService.set("retry-count", (retriesCount + 1).toString());
    }

    private errorCheck(): void {
        const timestamps = [
            +this.cookieService.get("first-error"),
            +this.cookieService.get("second-error"),
            +this.cookieService.get("third-error")];

        const meanTimestamp = timestamps.reduce((timestamp, value) => timestamp + value, 0) / 3;
        const meanDeviation = timestamps.reduce((totalDeviation, timestamp) => {
            return totalDeviation + Math.abs(timestamp - meanTimestamp);
        }, 0) / timestamps.length;

        if (meanDeviation <= 60 * 2) {
            this.retriesExceeded = true;
        }
    }
}
